import {taskAddLocalRequest, taskDataRequest} from "../store/actions/task.js";
import audioFile from '../assets/audio/notify.wav'
import icon from '../assets/img/BeOn.png'
import {REACT_SOCKET_URL} from '../config.js'
import {notificationRequest, surveySocket} from "../store/actions/notification.js";
import Api from "../Api.js";
import {surveyAddLocalRequest, surveyMessageRequest} from "../store/actions/dayoff.js";

let socket = null;
let reconnectTimeout = null;
const playNotificationSound = () => {
    const audio = new Audio(audioFile); // ✅ Path to sound file
    audio.play().catch((error) => console.error("🔇 Error playing sound:", error));
};
const showBrowserNotification = (data) => {
    if (document.hidden && Notification.permission === "granted") {
        const notification = new Notification("BeOn նոր հարցում", {
            body: data.title,
            icon: icon,
        });

        notification.onclick = function (event) {
            event.preventDefault();
            localStorage.setItem('redirectOnFocus', `/main_employee/surveys/${data.task.id}`); // Or dynamic: `/tasks/${data.task_id}`
            window.focus();
            window.location.href = `/main_employee/surveys/${data.task.id}`; // Or dynamic: `/tasks/${data.task_id}`
        };
    }
};

export const connectSurveySocket = (token, dispatch,) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/survey/?token=${token}`;

    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
        console.log("✅ WebSocket survey connected");
        dispatch(surveySocket('on'))

        if (reconnectTimeout) {
            clearTimeout(reconnectTimeout);
            reconnectTimeout = null;
        }
    };

    socket.onmessage = async (event) => {
        const data = JSON.parse(event.data);

        console.log(data, data.data)
        if (window.location.pathname === '/main_employee/surveys') {
            const list = await Api.getSurvey(window.location.search.substring(1)) // ✅ Dispatch inside component
            dispatch(surveyAddLocalRequest(list.data));
        }
        dispatch(surveyMessageRequest({...data.data,message:`Նոր հարցում - ${data.data.title}`,})); // ✅ Dispatch inside component
        playNotificationSound()
        showBrowserNotification(data.data);

        console.log("📩 Received survey update:", data);
    };

    socket.onclose = () => {
        console.warn("⚠️ WebSocket survey disconnected, attempting to reconnect...");
        reconnectSurveySocket(token, dispatch);
    };

    socket.onerror = (error) => {
        console.error("❌ WebSocket survey error:", error);
        dispatch(surveySocket('off'))
        socket.close();
    };
};

export const reconnectSurveySocket = (token, dispatch) => {
    if (!reconnectTimeout) {
        reconnectTimeout = setTimeout(() => {
            console.log("♻️ Reconnecting WebSocket survey...");
            dispatch(surveySocket('reconnect'))

            connectSurveySocket(token, dispatch);
        }, 3000);
    }
};

export const disconnectSurveySocket = () => {
    if (socket) {
        socket.close();
    }
};
